import { render, staticRenderFns } from "./ProjectsItemExamsComponent.vue?vue&type=template&id=1ba1f0b6&scoped=true&"
import script from "./ProjectsItemExamsComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsItemExamsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba1f0b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VSheet})
